import { render } from "./PageHeading.vue?vue&type=template&id=7c34044c"
import script from "./PageHeading.vue?vue&type=script&lang=js"
export * from "./PageHeading.vue?vue&type=script&lang=js"

import exportComponent from "D:\\PHPStormProjects\\hqam-customer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__